/* ============================================================
   Generic accordion groups — [data-accordion] (Topics, FAQ)
   ------------------------------------------------------------
   Single-open-per-group `.accordion-item` list; toggles `is-open`
   and keeps `.accordion-trigger[aria-expanded]` in sync.
   Mirrors csd-common.css / faq.css / software-type.css accordion styles.
   ============================================================ */
// export function initAccordionGroups() {
//   document.querySelectorAll("[data-accordion]").forEach(function (group) {
//     var items = Array.prototype.slice.call(
//       group.querySelectorAll(".accordion-item")
//     );

//     items.forEach(function (item) {
//       var trigger = item.querySelector(".accordion-trigger");
//       if (!trigger) return;

//       trigger.setAttribute(
//         "aria-expanded",
//         item.classList.contains("is-open") ? "true" : "false"
//       );

//       trigger.addEventListener("click", function () {
//         var willOpen = !item.classList.contains("is-open");
//         items.forEach(function (other) {
//           other.classList.remove("is-open");
//           var t = other.querySelector(".accordion-trigger");
//           if (t) t.setAttribute("aria-expanded", "false");
//         });
//         if (willOpen) {
//           item.classList.add("is-open");
//           trigger.setAttribute("aria-expanded", "true");
//         }
//       });
//     });
//   });
// }
export function initAccordionGroups() {
  document.querySelectorAll("[data-accordion]").forEach(function (group) {
    var items = Array.prototype.slice.call(
      group.querySelectorAll(".accordion-item")
    );

    var triggers = [];

    items.forEach(function (item) {
      var trigger = item.querySelector(".accordion-trigger");
      if (!trigger) return;

      // Make the trigger keyboard-focusable and announce it as a button
      trigger.setAttribute("role", "button");
      trigger.setAttribute("tabindex", "0");

      trigger.setAttribute(
        "aria-expanded",
        item.classList.contains("is-open") ? "true" : "false"
      );

      triggers.push(trigger);

      // Click on the entire accordion item
      item.addEventListener("click", function (e) {
        // Allow links inside the content to work normally
        if (e.target.closest("a")) return;

        var willOpen = !item.classList.contains("is-open");

        items.forEach(function (other) {
          other.classList.remove("is-open");
          var t = other.querySelector(".accordion-trigger");
          if (t) t.setAttribute("aria-expanded", "false");
        });

        if (willOpen) {
          item.classList.add("is-open");
          trigger.setAttribute("aria-expanded", "true");
        }
      });

      // Keyboard support on the trigger itself
      trigger.addEventListener("keydown", function (e) {
        var i = triggers.indexOf(trigger);

        switch (e.key) {
          case "Enter":
          case " ":
          case "Spacebar":
            e.preventDefault(); // stop page scroll on Space
            trigger.click(); // reuses your existing item click logic
            break;
          case "ArrowDown":
            e.preventDefault();
            triggers[(i + 1) % triggers.length].focus();
            break;
          case "ArrowUp":
            e.preventDefault();
            triggers[(i - 1 + triggers.length) % triggers.length].focus();
            break;
          case "Home":
            e.preventDefault();
            triggers[0].focus();
            break;
          case "End":
            e.preventDefault();
            triggers[triggers.length - 1].focus();
            break;
        }
      });
    });
  });
}